import Base from 'app/collections/base';
import { appUrl } from 'utils/wrappers';
import CarrierAccount from 'app/models/carrier_account';

export default Base.extend({
  model: CarrierAccount,
  url: appUrl('carrier_accounts'),
  comparator: 'readable',
});



// WEBPACK FOOTER //
// ./app/collections/carrier_accounts.js